import React from 'react';
import OptionGroup from "../OptionBuilder/OptionGroup";

export default function LogoPicker({option, name = 'logo', id = 'lloyd-logos', ...props}) {
  let values = option.allValues();

  return (
    <div className="inner">
      <OptionGroup {...props} option={option} id={id} name={name} values={values}/>
    </div>);
}
